<svg width="17" height="17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12.137 10.516a2.5 2.5 0 0 0-1.944.945L6.538 9.176a2.23 2.23 0 0 0 0-1.32l3.655-2.285a2.5 2.5 0 1 0-.555-1.555c.002.224.036.446.1.66L6.083 6.961a2.5 2.5 0 1 0 0 3.11l3.655 2.285a2.395 2.395 0 0 0-.1.66 2.5 2.5 0 1 0 2.5-2.5Zm0-8a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm-8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm8 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
    fill="currentColor"
  />
</svg>
